import React from 'react';
import { Drawer, DrawerActions } from '../../Drawer';
import { Bodytext, CheckboxText, StyledCheckboxInput, TierContainer, TierLevelContainer, TierPriceContainer } from './styled-components';
export var UpgradeModal = function UpgradeModal(_ref) {
  var checkBoxText = _ref.checkBoxText,
      checkedAgreement = _ref.checkedAgreement,
      currentTierPrice = _ref.currentTierPrice,
      handleModalClose = _ref.handleModalClose,
      handleModalContinue = _ref.handleModalContinue,
      newTierPrice = _ref.newTierPrice,
      setCheckedAgreement = _ref.setCheckedAgreement,
      setUpgradeModalIsOpen = _ref.setUpgradeModalIsOpen,
      subtitle = _ref.subtitle,
      title = _ref.title,
      upgradeModalIsOpen = _ref.upgradeModalIsOpen;

  var onClose = function onClose() {
    handleModalClose();
    setUpgradeModalIsOpen(false);
    setCheckedAgreement(false);
  };

  var checkedAgreementHandler = function checkedAgreementHandler() {
    setCheckedAgreement(!checkedAgreement);
  };

  return /*#__PURE__*/React.createElement(Drawer, {
    isOpen: upgradeModalIsOpen,
    title: title,
    onClose: onClose
  }, /*#__PURE__*/React.createElement(Bodytext, null, subtitle), /*#__PURE__*/React.createElement(TierContainer, null, /*#__PURE__*/React.createElement(TierLevelContainer, null, "Current Tier"), /*#__PURE__*/React.createElement(TierPriceContainer, null, currentTierPrice)), /*#__PURE__*/React.createElement(TierContainer, null, /*#__PURE__*/React.createElement(TierLevelContainer, null, "New Tier"), /*#__PURE__*/React.createElement(TierPriceContainer, null, newTierPrice)), /*#__PURE__*/React.createElement(StyledCheckboxInput, {
    checked: checkedAgreement,
    id: "agreement",
    label: /*#__PURE__*/React.createElement(CheckboxText, null, checkBoxText),
    name: "checkbox",
    onChange: function onChange() {
      return checkedAgreementHandler();
    }
  }), /*#__PURE__*/React.createElement(DrawerActions, {
    actions: [{
      disabled: !checkedAgreement,
      handler: handleModalContinue,
      label: 'Upgrade',
      testId: 'upgrade_button'
    }]
  }));
};